import { toast } from 'react-toastify';
import { StoreDetailsStore } from 'zustand-store';
import { KycStatus } from 'types';
import { Anchor, Button, Header, Loading, Main } from 'components';
import { routes } from 'commons';
import { StoreInfos, StoreMapAndRegulatoryInformation } from './components';

export function ProfilePage() {
  const { storeDetails, error, isLoading } =
    StoreDetailsStore.useGetStoreDetails({
      fullHistory: true,
      revalidate: true,
    });

  const {
    name,
    displayName,
    address,
    notificationEmail,
    participateInPickUpStore,
    participateInStoreShipping,
    geoPoint,
    discountAllowed,
    exchangeOmniEnable,
    kycStatus,
  } = storeDetails || {};

  function redirectToRequestChange() {
    if (error) {
      return toast.error('Não foi possível solicitar alteração');
    }

    const waText = encodeURI(
      `Olá! Somos a loja *${name} - ${displayName}* e gostaríamos de alterar `
    );
    const waUrl = `https://api.whatsapp.com/send?phone=+555121295354&text=${waText}`;

    window.open(waUrl, '_blank');
  }

  if (isLoading) {
    return (
      <Main>
        <Header />

        <div className="flex flex-col gap-6 overflow-y-scroll h-full pt-5 pb-14 px-7 md:px-12">
          <Loading />
        </div>
      </Main>
    );
  }

  return (
    <Main>
      <Header />

      <div className="flex flex-col gap-6 overflow-y-scroll h-full pt-5 pb-14 px-7 md:px-12">
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-bold">Informações da loja</h1>
          <p className="text-base">
            Confira os dados e configurações gerais de sua loja.
          </p>
        </div>

        <div className="flex gap-6 flex-wrap">
          <StoreInfos
            discountAllowed={discountAllowed}
            exchangeOmniEnable={exchangeOmniEnable}
            participateInPickUpStore={participateInPickUpStore}
            participateInStoreShipping={participateInStoreShipping}
            address={address}
            notificationEmail={notificationEmail || []}
          />

          <StoreMapAndRegulatoryInformation
            isPickUpAble={participateInPickUpStore}
            isStoreShippingAble={participateInStoreShipping}
            geoPoint={geoPoint}
            kycStatus={kycStatus || KycStatus.Undefined}
          />
        </div>

        <div className="flex flex-col gap-2">
          <h3 className="text-base font-bold">Outras configurações</h3>
          <p className="text-xs">
            Tenha acesso direto as páginas de outras configurações:
          </p>

          <div className="flex gap-x-7 gap-y-1 sm:flex-row flex-col">
            <Button variant="link" onClick={redirectToRequestChange}>
              Solicitar Alteração
            </Button>

            <Anchor to={routes.discount.path}>Descontos</Anchor>

            <Anchor to={routes.openingDays.path}>
              Horários de atendimento
            </Anchor>
          </div>
        </div>
      </div>
    </Main>
  );
}
